
(() => {
  const config = JSON.parse(document.getElementById('fellow-coffee-config').textContent);
  const root = config.root || '/';
  const P = {
    stagg:  { name:'Stagg EKG Pro Kettle', handle:'stagg-ekg-electric-kettle-variable-temp-104-212-f-30-oz', legend:'Handle', def:1, v:[
              { id:44486898516067, label:'Matte black', price:179.95, img:'stagg-black' },
              { id:44486898548835, label:'Walnut handle', price:199.95, img:'stagg-walnut' } ] },
    opus:   { name:'Opus 2 Burr Grinder', handle:'opus-2-conical-burr-grinder-48mm-burrs-stepless-adjustment', v:[
              { id:44486896943203, label:'Black', price:199.95, img:'opus' } ] },
    clara:  { name:'Clara French Press', handle:'clara-french-press-24-oz-vacuum-insulated-stainless-steel', v:[
              { id:44486897598563, label:'Matte black', price:99.95, img:'clara' } ] },
    pirch:  { name:'Pirch Latte Glasses, pair', handle:'pirch-espresso-glasses-soda-lime-glass-set-of-2', legend:'Tint', def:0, v:[
              { id:44486899630179, label:'Amber', price:44.95, img:'pirch-amber', sw:'#B4722C' },
              { id:44486899564643, label:'Smoke', price:44.95, img:'pirch-smoke', sw:'#6E6C67' },
              { id:44486899597411, label:'Garnet', price:44.95, img:'pirch-garnet', sw:'#7A2140' },
              { id:44486899662947, label:'Woodland', price:44.95, img:'pirch-woodland', sw:'#3E5B3D' } ] },
    carter: { name:'Carter Move Mug, 12 oz', handle:'carter-move-mug-true-taste-ceramic-interior-12-oz', v:[
              { id:44486899269731, label:'Matte black', price:30.00, img:'carter' } ] }
  };
  const ORDER = ['stagg','opus','clara','pirch','carter'];
  const KEY = 'rarely-fellow-bar-v1';
  const money = n => Number.isFinite(n) ? '$' + n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}) : 'Price unavailable';
  const whole = n => '$' + Math.round(n).toLocaleString('en-US');
  const $$ = (s, r=document) => Array.from(r.querySelectorAll(s));

  // ---- state ----
  const state = { sel:{}, lines:{} };
  ORDER.forEach(k => state.sel[k] = P[k].def || 0);
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && saved.sel && saved.lines) {
      ORDER.forEach(k => {
        if (Number.isInteger(saved.sel[k]) && P[k].v[saved.sel[k]]) state.sel[k] = saved.sel[k];
        const q = saved.lines[k] && saved.lines[k].q;
        if (Number.isSafeInteger(q) && q > 0) state.lines[k] = { q: Math.min(9, q) };
      });
    }
  } catch (e) {}
  const save = () => { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} };
  const variant = k => P[k].v[state.sel[k]];
  const soldOut = new Set();
  let catalogReady = false, busy = false, cartUncertain = false;
  ORDER.forEach(k => P[k].v.forEach(v => { v.price = null; soldOut.add(v.id); }));
  const purchasable = k => catalogReady && Number.isFinite(variant(k).price) && !soldOut.has(variant(k).id);
  const canCheckout = () => catalogReady && !busy && !cartUncertain && count() > 0 && ORDER.filter(k => state.lines[k]).every(purchasable);
  const error = message => {
    const el = document.querySelector('[data-commerce-error]');
    el.textContent = message; el.hidden = !message;
  };

  // ---- options ----
  $$('[data-opts]').forEach((slot, i) => {
    const k = slot.dataset.opts, p = P[k];
    const fs = document.createElement('fieldset');
    fs.className = 'opts';
    fs.innerHTML = `<legend>${p.legend}</legend>` + p.v.map((v, j) =>
      `<label class="opt"><input type="radio" name="${k}-opt-${i}" value="${j}" data-opt="${k}">` +
      `<span>${v.sw ? `<i style="background:${v.sw}"></i>` : ''}${v.label}</span></label>`
    ).join('');
    slot.replaceWith(fs);
  });
  document.addEventListener('change', e => {
    const t = e.target;
    if (t.matches('[data-opt]') && !busy && !t.disabled && P[t.dataset.opt].v[+t.value]) { state.sel[t.dataset.opt] = +t.value; save(); render(); }
  });

  // ---- add / remove ----
  document.addEventListener('click', e => {
    if (busy || e.target.closest('[disabled], [aria-disabled="true"]')) { e.preventDefault(); return; }
    const add = e.target.closest('[data-add]');
    if (add) {
      const k = add.dataset.add;
      if (state.lines[k]) delete state.lines[k]; else if (purchasable(k)) state.lines[k] = { q:1 };
      save(); render(); return;
    }
    const q = e.target.closest('[data-q]');
    if (q) {
      const k = q.dataset.k, d = +q.dataset.q;
      if (!state.lines[k]) return;
      if (d > 0 && !purchasable(k)) return;
      state.lines[k].q += d;
      if (state.lines[k].q <= 0) delete state.lines[k];
      if (state.lines[k] && state.lines[k].q > 9) state.lines[k].q = 9;
      save(); render(); return;
    }
    if (e.target.closest('[data-checkout]') || e.target.closest('[data-bar-btn]')) {
      if (count() === 0) { document.getElementById('menu').scrollIntoView(); return; }
      e.preventDefault(); checkout(); return;
    }
    if (e.target.closest('[data-empty-add]')) { addAll(); }
  });
  const addAll = () => {
    if (busy || !ORDER.every(purchasable)) return;
    ORDER.forEach(k => { if (!state.lines[k]) state.lines[k] = { q:1 }; });
    save(); render();
  };
  document.getElementById('addAll').addEventListener('click', addAll);

  const count = () => ORDER.reduce((n, k) => n + (state.lines[k] ? state.lines[k].q : 0), 0);
  const total = () => ORDER.reduce((n, k) => n + (state.lines[k] ? state.lines[k].q * (variant(k).price ?? NaN) : 0), 0);
  const fullBar = () => ORDER.reduce((n, k) => n + (variant(k).price ?? NaN), 0);

  // ---- render ----
  function render() {
    ORDER.forEach(k => {
      const v = variant(k), on = !!state.lines[k], out = soldOut.has(v.id);
      $$(`[data-price="${k}"]`).forEach(el => el.textContent = money(v.price));
      $$(`[data-img="${k}"]`).forEach(el => { const src = config.images[v.img]; if (src && el.src !== src) el.src = src; });
      $$(`input[data-opt="${k}"]`).forEach(inp => {
        inp.checked = +inp.value === state.sel[k];
        inp.disabled = busy || !catalogReady || soldOut.has(P[k].v[+inp.value].id);
      });
      $$(`[data-add="${k}"]`).forEach(b => {
        b.setAttribute('aria-pressed', on);
        const inMenu = !!b.closest('.paper');
        const label = b.querySelector('[data-add-label]');
        label.textContent = !catalogReady ? 'Checking availability' : out && !on ? 'Unavailable' : on ? (inMenu ? 'Added' : 'In your order') : (inMenu ? 'Add' : 'Add to order');
        b.disabled = busy || !catalogReady || (out && !on);
        b.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + P[k].name + (P[k].v.length > 1 ? ', ' + v.label : '') + (on ? ' from your order' : ' to your order'));
      });
    });

    // ticket
    const lines = document.querySelector('[data-lines]');
    const n = count(), t = total();
    if (n === 0) {
      lines.innerHTML = `<li class="empty">Nothing on your ticket yet.<br>Add a tool from the menu, or <button type="button" data-empty-add>take the full bar</button>.</li>`;
    } else {
      lines.innerHTML = ORDER.filter(k => state.lines[k]).map(k => {
        const v = variant(k), q = state.lines[k].q;
        return `<li class="line"><span class="line-name">${P[k].name}</span><span class="line-amt">${money((v.price ?? NaN)*q)}</span>` +
          `<span class="line-var">${v.label}${purchasable(k) ? '' : ' — unavailable; remove or choose another option'}</span>` +
          `<span class="qty"><button type="button" data-k="${k}" data-q="-1" aria-label="One fewer ${P[k].name}">−</button><span aria-label="Quantity">${q}</span><button type="button" data-k="${k}" data-q="1" aria-label="One more ${P[k].name}">+</button></span></li>`;
      }).join('');
    }
    document.querySelector('[data-total]').textContent = money(t);
    const co = document.querySelector('[data-checkout]');
    co.disabled = !canCheckout();
    co.textContent = busy ? 'Checking your order…' : n ? `Check out, ${money(t)}` : 'Check out';
    $$('[data-q]').forEach(b => { b.disabled = busy || (+b.dataset.q > 0 && !purchasable(b.dataset.k)); });
    $$('[data-count]').forEach(el => el.textContent = n);
    $$('[data-fullbar]').forEach(el => el.textContent = money(fullBar()));
    const all = ORDER.every(k => state.lines[k]);
    const addAllBtn = document.getElementById('addAll');
    addAllBtn.disabled = busy || all || !ORDER.every(purchasable);
    addAllBtn.textContent = all ? 'All five are on your ticket' : 'Add all five to my order';

    // sticky bar + closing CTA
    const barText = document.querySelector('[data-bar-text]'), barBtn = document.querySelector('[data-bar-btn]');
    barBtn.disabled = busy || (n > 0 && !canCheckout());
    if (n) { barText.innerHTML = `Your order: <b>${n} ${n === 1 ? 'item' : 'items'}, ${money(t)}</b>`; barBtn.textContent = 'Check out'; }
    else { barText.innerHTML = `The full Fellow bar: <b>${money(fullBar())}</b>`; barBtn.textContent = 'See the menu'; }
    const lc = document.querySelector('[data-last-cta]'), ln = document.querySelector('[data-last-note]');
    lc.setAttribute('aria-disabled', String(busy || (n > 0 && !canCheckout())));
    if (n) { lc.textContent = `Check out, ${money(t)}`; lc.setAttribute('href', '#'); lc.dataset.checkout = ''; ln.textContent = ''; }
    else { lc.textContent = 'Build my coffee bar'; lc.setAttribute('href', '#menu'); delete lc.dataset.checkout; ln.textContent = `The full bar is ${money(fullBar())}.`; }
    calc();
  }

  // No cart clear/update, permalink fallback, or retry after a potentially applied POST.
  async function checkout() {
    if (!canCheckout()) return;
    const selected = ORDER.filter(k => state.lines[k]);
    const items = selected.map(k => ({ id: variant(k).id, quantity: state.lines[k].q }));
    const prices = selected.map(k => variant(k).price);
    busy = true; error(''); render();
    let postStarted = false;
    try {
      await refreshCatalog();
      if (!selected.every((k, i) => purchasable(k) && variant(k).id === items[i].id)) {
        throw new Error('An item in your order is unavailable. Remove it or choose another option before checking out.');
      }
      if (selected.some((k, i) => variant(k).price !== prices[i])) {
        throw new Error('A price changed. Review the updated total, then check out again.');
      }
      postStarted = true;
      const response = await request(config.cartAdd, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Shopify could not add this order.');
      const added = await response.json();
      if (!Array.isArray(added.items) || !items.every(item => added.items.some(line => Number(line.variant_id || line.id) === item.id && line.quantity >= item.quantity))) {
        throw new Error('Shopify did not confirm every item.');
      }
      location.assign(root + 'checkout');
      // Keep the guard until navigation; rapid subsequent clicks must not POST again.
      return;
    } catch (err) {
      if (postStarted) {
        cartUncertain = true;
        document.querySelector('[data-cart-review]').hidden = false;
        error('We could not confirm your cart update. Some items may already be in your cart. Review your cart before trying again; we have not submitted another add.');
      } else {
        error(err.message || 'Could not verify this order. Please retry availability.');
      }
    }
    busy = false; render();
    document.querySelector('[data-commerce-error]').focus();
  }

  // A bounded request prevents a stalled connection from trapping the busy state.
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, { credentials:'same-origin', ...options, signal:controller.signal });
      const data = response.ok ? await response.json() : null;
      return { ok:response.ok, json:async () => data };
    }
    finally { clearTimeout(timer); }
  }

  // Atomic, fail-closed catalog hydration. Never replace a shopper's chosen variant.
  async function refreshCatalog() {
    catalogReady = false;
    ORDER.forEach(k => P[k].v.forEach(v => { v.price = null; soldOut.add(v.id); }));
    document.querySelector('[data-commerce-status]').textContent = 'Checking prices and availability…';
    document.querySelector('[data-retry]').hidden = true;
    render();
    try {
      const products = await Promise.all(ORDER.map(async k => {
        const response = await request(`${root}products/${P[k].handle}.js`, { cache:'no-store', headers:{ Accept:'application/json' } });
        if (!response.ok) throw new Error('Could not check availability. Please retry.');
        const product = await response.json();
        if (!Array.isArray(product.variants)) throw new Error('Could not check availability. Please retry.');
        return product;
      }));
      products.forEach((product, i) => P[ORDER[i]].v.forEach(v => {
        const live = product.variants.find(candidate => String(candidate.id) === String(v.id));
        // Missing, string, null, negative, fractional and nonfinite prices are not sellable.
        if (!live || !Number.isSafeInteger(live.price) || live.price < 0) return;
        v.price = live.price / 100;
        if (live.available === true) soldOut.delete(v.id);
      }));
      catalogReady = true;
      document.querySelector('[data-commerce-status]').textContent = ORDER.every(purchasable) ? '' : 'Some options are unavailable. Please review your ticket.';
    } catch (err) {
      document.querySelector('[data-commerce-status]').textContent = 'Prices and availability could not be verified.';
      document.querySelector('[data-retry]').hidden = false;
      throw err;
    } finally { render(); }
  }
  document.querySelector('[data-retry]').addEventListener('click', async () => {
    if (busy) return;
    busy = true; error('');
    try { await refreshCatalog(); } catch (err) { error('Could not check availability. Please retry.'); }
    finally { busy = false; render(); }
  });

  // ---- café math ----
  const cups = document.getElementById('cups'), cupsOut = document.getElementById('cupsOut');
  const BEAN = 0.90;
  function calc() {
    const c = +cups.value;
    const price = +(document.querySelector('input[name=cupPrice]:checked') || {}).value || 6;
    cupsOut.textContent = c;
    cups.style.setProperty('--fill', ((c - 1) / 20 * 100) + '%');
    const year = c * price * 52, beans = c * BEAN * 52, week = c * (price - BEAN);
    const weeks = Math.ceil(fullBar() / week);
    document.querySelector('[data-calc="year"]').textContent = whole(year);
    document.querySelector('[data-calc="beans"]').textContent = 'about ' + whole(beans);
    document.querySelector('[data-calc="week"]').textContent = money(week);
    let when;
    if (weeks <= 10) when = `${weeks} week${weeks === 1 ? '' : 's'}`;
    else if (weeks < 100) when = `${Math.round(weeks / 4.345)} months`;
    else when = `${(weeks / 52).toFixed(1).replace('.0','')} years`;
    document.querySelector('[data-calc="payback"]').textContent = Number.isFinite(fullBar()) ? `The whole bar pays for itself in about ${when}, then keeps pouring.` : 'Payback estimate available once prices are verified.';
  }
  cups.addEventListener('input', calc);
  $$('input[name=cupPrice]').forEach(r => r.addEventListener('change', calc));

  // ---- sticky order bar ----
  const bar = document.querySelector('.orderbar');
  let pastHero = false, ticketVisible = false;
  const syncBar = () => {
    const show = pastHero && !ticketVisible;
    bar.classList.toggle('show', show);
    bar.setAttribute('aria-hidden', !show);
    bar.querySelector('[data-bar-btn]').tabIndex = show ? 0 : -1;
  };
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => { pastHero = !en.isIntersecting; syncBar(); }, { rootMargin:'-60% 0px 0px 0px' }).observe(document.querySelector('.hero'));
    new IntersectionObserver(([en]) => { ticketVisible = en.isIntersecting; syncBar(); }, { threshold:0.15 }).observe(document.getElementById('ticket'));
  }

  // ---- the lights come on, then the gold catches them ----
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const open = () => {
    document.body.classList.add('is-lit');
    if (reduce) return;
    setTimeout(() => {
      ['glintA','glintB'].forEach(id => { const a = document.getElementById(id); if (a && a.beginElement) a.beginElement(); });
    }, 1150);
  };
  const ready = () => requestAnimationFrame(() => setTimeout(open, 120));
  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(() => {
    const img = document.querySelector('.window .photo');
    if (img.complete) ready(); else { img.addEventListener('load', ready, { once:true }); setTimeout(ready, 2500); }
  });

  render();
  save();
  refreshCatalog().catch(() => error('Could not check prices and availability. Please retry.'));
})();
